import "../styles/Background.scss";

const rand = (min, max) => Math.random() * (max - min) + min;
const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

const SYMBOL_COLORS = [
  { color: "#00ffff", shadow: "#00ffff" },
  { color: "#ff0055", shadow: "#ff0055" },
  { color: "#ffdd00", shadow: "#ffdd00" },
  { color: "#ff9900", shadow: "#ff9900" },
  { color: "#ffffff", shadow: "#fff" },
];
const STAR_COLORS = ["#ffffff", "#ffffff", "#ffffff", "#00ffff", "#ff00ff"];

const SYMBOLS = Array.from({ length: 60 }, () => ({
  top: `${rand(0, 98)}%`,
  left: `${rand(0, 95)}%`,
  ...pick(SYMBOL_COLORS),
  rotate: rand(-20, 20),
  size: rand(10, 16),
  symbol: pick(["×", "○", "□", "△"]),
  tx: `${rand(-40, 40)}px`,
  ty: `${rand(-40, 40)}px`,
  duration: rand(8, 22),
  delay: rand(0, 12),
}));

const STARS = Array.from({ length: 300 }, () => ({
  top: `${rand(0, 100)}%`,
  left: `${rand(0, 100)}%`,
  size: rand(0.8, 2.2),
  opacity: rand(0.4, 0.9),
  color: pick(STAR_COLORS),
}));

const Background = () => (
  <div className="bg-overlay">
    {STARS.map((s, idx) => (
      <span
        key={`s${idx}`}
        className="bg-overlay__star"
        style={{
          top: s.top,
          left: s.left,
          width: `${s.size}px`,
          height: `${s.size}px`,
          opacity: s.opacity,
          backgroundColor: s.color,
        }}
      />
    ))}
    {SYMBOLS.map((el, idx) => (
      <span
        key={`el${idx}`}
        className="bg-overlay__el"
        style={{
          top: el.top,
          left: el.left,
          color: el.color,
          textShadow: `0 0 8px ${el.shadow}, 0 0 16px ${el.shadow}`,
          fontSize: `${el.size}px`,
          '--rot': `${el.rotate}deg`,
          '--tx': el.tx,
          '--ty': el.ty,
          animation: `float-symbol ${el.duration}s ease-in-out ${el.delay}s infinite`,
        }}
      >
        {el.symbol}
      </span>
    ))}
  </div>
);

export default Background;
